export default __webpack_public_path__ + "static/logo-28f56e690324f24373001e30d084153c.png";